import cx from 'classnames';
import {OnboardingModalButton} from '~/CreateFabricInvitation/components/NavHeader/OnboadingModalButton/OnboardingModalButton';
import {PreviewButtons} from '~/CreateFabricInvitation/components/PreviewButtons/PreviewButtons';
import {navigateToRoute} from '~/CreateFabricInvitation/navigation';
import {isInAppMode} from '~/common/checkout/utils/app';
import {isFabricWebview} from '~/common/utils/webview';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';
import {DiamondIcon} from '~library/svg/DiamondIcon';

export const HeaderNavigation = ({
  currentRoute,
  isLargishAndUp,
  isPremium,
  showSteps,
  stepLabel,
  isGuestStep,
  eventId,
  totalSteps,
  handleShowLeaveModal,
  onSave,
  premiumPreview,
  store,
}) => {
  const inAppMode = isInAppMode();
  if (currentRoute.showMegaNav) {
    return null;
  }

  return (
    <nav className={cx('fabric-header__nav', {frp: currentRoute.id > totalSteps})}>
      <div
        className={cx('fabric-header__left-wrap', {
          'fabric-header__left-wrap--guest-page': isGuestStep,
        })}
      >
        {!inAppMode && (
          <Button
            id="closeBtn"
            data-qa-id="exit-create"
            className="fabric-header__back"
            variant="transparent"
            size="small"
            onClick={handleShowLeaveModal}
            ariaLabel="Close"
          >
            <CloseLineIcon ratio={0.75} />
          </Button>
        )}
        <div className="fabric-header__step-wrap">
          <Typography
            variant="list2"
            size="large"
            color="pebble"
            className="fabric-header__step-count"
          >
            {isPremium && (
              <span className="fabric-header__is-premium">
                <DiamondIcon ratio={16 / 14.0} />
                {isLargishAndUp && (
                  <Typography variant="list2" as="span" size="large" color="roseWebText">
                    Premium
                  </Typography>
                )}
              </span>
            )}
            {isPremium && showSteps && ' '}
            {stepLabel}
          </Typography>
          <Typography variant="list2" as="h1" size="large" className="fabric-header__step-name">
            &nbsp;
            {currentRoute.displayName || ''}
          </Typography>
        </div>
        {currentRoute.linkPreview && (
          <Button
            id="continueBtn"
            data-qa-id="continueBtn"
            className="fabric-header__continue"
            ariaLabel="Preview"
            variant="link"
            size="large"
            onClick={() => {
              navigateToRoute('preview', store, false, false, [window.canvas]);
            }}
          >
            Preview
          </Button>
        )}
        {currentRoute.linkBack && (
          <Button
            id="continueBtn"
            data-qa-id="continueBtn"
            className="fabric-header__continue"
            variant="link"
            size="large"
            onClick={() => navigateToRoute('back', store)}
            ariaLabel="Back"
          >
            Back
          </Button>
        )}
        {currentRoute.previewButtons && !premiumPreview && (
          <PreviewButtons onSave={onSave} eventId={eventId} isDesktop={isLargishAndUp} />
        )}
      </div>
      <OnboardingModalButton visible={currentRoute.id === 1 && !isFabricWebview()} />
    </nav>
  );
};
